import React from 'react';
// import { Button } from 'antd';
import Button from '../../Button';
import { LocalizationContext } from '../../../hoc/Localization';
import Section from '../Section';
import explore from './explore.json';
import styles from './styles.less';
import Router from '../../../routes';
import { LocationContext } from '../../../hoc/Location';
import { SettingsContext } from '../../../hoc/Settings';

const Explore = () => {
  const { t, locale } = React.useContext(LocalizationContext);
  const { location } = React.useContext(LocationContext);
  const {
    domainSettings: {
      facebook: { testLink },
    },
  } = React.useContext(SettingsContext);
  const { center, zoom } = location;

  const initialState = {
    currentStep: -1,
    answers: [],
    mode: '',
  };

  const [state, setState] = React.useState(initialState);
  const { currentStep, answers, mode } = state;
  const totalSteps = mode ? explore[mode].length : null;

  React.useEffect(() => {
    const storageState = JSON.parse(localStorage.getItem('explore')) || {};

    setState({
      ...state,
      ...storageState,
    });
  }, []);

  const saveExplore = () => {
    localStorage.setItem('explore', JSON.stringify(state));
  };

  const startExplore = () => {
    state.currentStep++;

    setState({ ...state });
    saveExplore({ ...state });
  };

  const submitSearch = values => {
    const search = [];
    const result = values.find(answer => answer.value === 'TEST');

    values.map((item, index) => {
      search[index] = item.value;
      return null;
    });

    const queryParams = { ...center, zoom, search };
    if (result) {
      window.open(testLink, '_blank');
    } else {
      queryParams.search = queryParams.search.filter(s => s !== undefined);
      Router.pushRoute('search', { locale, queryParams });
    }

    localStorage.removeItem('explore');
    setState(initialState);
  };

  const setAnswer = option => {
    if (!mode) {
      state.mode = option.value;
    } else {
      state.answers[currentStep - 1] = option;
    }

    state.currentStep++;

    setState({ ...state });
    saveExplore({ ...state });

    if (totalSteps && currentStep >= totalSteps) {
      return submitSearch(state.answers);
    }

    return null;
  };

  const prevStep = event => {
    if (currentStep > 1) {
      state.currentStep = currentStep - 1;

      setState({ ...state });
      saveExplore({ ...state });

      event.preventDefault();
    }
  };

  if (currentStep < 0) {
    return (
      <Section
        title={t('explorer.title')}
        description={t('explorer.subtitle')}
        button={
          <span id="exploreButton" className="buttonText medium" onClick={startExplore}>
            {t('search.submit')}
          </span>
        }
        icon="../static/images/frontpage/explore.svg"
      />
    );
  }

  const step = { ...explore[mode][mode === '' ? currentStep : currentStep - 1] };
  const result = answers.find(answer => answer.value === 'English');

  if (step && step.key && step.key === 'levels' && !result) {
    step.options = step.options.filter(o => o.value !== 'TEST');
  }

  step.title = t(`${mode}.explorer.question_${currentStep}`);
  step.options = step.options.map((option, index) => ({
    ...option,
    title: t(`${mode}.explorer.option_${currentStep}_${index + 1}`),
  }));

  let i = 0;
  const progress = [];
  while (i < totalSteps) {
    progress.push(
      <div className={i < currentStep ? styles.completed : null} key={`progress-${i}`} />,
    );
    i++;
  }

  return (
    <div className={styles.steps}>
      <div>
        <p className={styles.question}>{step.title}</p>

        {!!mode && (
          <div>
            <div>
              <span>{t('explorer.step')}</span>
              {currentStep}
              /
              {totalSteps}
            </div>
            <div className={styles.progress}>{progress}</div>
          </div>
        )}

        <div className={styles.options} key={`explore-options-${currentStep}`}>
          {step.options &&
            step.options.map((option, index) => (
              <Button
                version="large"
                type="secondary"
                key={`explore-option-${index + 1}`}
                id={`explore${index}`}
                className={`explorer.option_${currentStep}_${index + 1}`}
                block
                onClick={() => setAnswer(option)}
              >
                {option.title}
                {!!option.note && <div className={styles.note}>{t('explorer.option.note')}</div>}
              </Button>
            ))}
        </div>

        <a
          className={currentStep > 1 ? styles.previous : styles.previousDisabled}
          onClick={event => prevStep(event)}
        >
          Previous
        </a>
      </div>

      <div className={styles.imageContainer}>
        <img src="/static/images/frontpage/explore.svg" alt="title" />
      </div>
    </div>
  );
};

export default Explore;
